import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppContext } from "../../AppProvider";
import { faLoader, faLongArrowRight } from "../../utilities/fontawesomeIcons";
import { useShipmentsStatisticsContext } from "./providers/ShipmentsStatistics";
import moment from "moment";
import { useShipmentsContext } from "./providers/Shipments";

const ReportCard: React.FC<{
  title?: string;
  subtitle?: string;
  path?: string;
  additionalFilters?: object;
  provider?: string;
}> = ({
  title = "",
  subtitle = "",
  path = "#",
  additionalFilters = {},
  provider = "statistics",
}) => {
  const { data, loader, filters } =
    provider === "statistics"
      ? useShipmentsStatisticsContext()
      : useShipmentsContext();
  const { dictionary } = useAppContext();

  return (
    <div className="report">
      <div className="polygon"></div>
      <span className="type">{title.toUpperCase()}</span>
      <span className="period">{subtitle.toUpperCase()}</span>
      <span className="counter">
        {loader ? <FontAwesomeIcon icon={faLoader} spin /> : data?.total}
      </span>
      <Link
        className="link text-end"
        to={path}
        onClick={() => {
          if (filters) {
            const filtersNormalized = {
              creationDate: [
                moment(filters.start).toDate(),
                moment(filters.end).toDate(),
              ],
              ...additionalFilters,
            };
            localStorage.setItem(
              "page_filters",
              JSON.stringify(filtersNormalized)
            );
          }
        }}
      >
        {dictionary.actions.see_all}
        <FontAwesomeIcon icon={faLongArrowRight} size="1x" />
      </Link>
    </div>
  );
};

export { ReportCard };
